import { render, staticRenderFns } from "./FundingProjectsRequests.vue?vue&type=template&id=5429056a&"
import script from "./FundingProjectsRequests.vue?vue&type=script&lang=js&"
export * from "./FundingProjectsRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports